import { ErrorObject } from '@qpr/client-library/dist/esm/ErrorContext';

type InformationItem = {
  name: string;
  link: string;
};

export type Data = {
  role?: string;
  tasks?: string;
  informationitems?: InformationItem;
};

export interface DataTableState {
  data: Data[];
  error?: ErrorObject;
}

const initialState = {
  data: []
} as DataTableState;

export default initialState;
